/* eslint-disable max-len */

/**
 * @author: Matthew Rawson @ 04/09/2017 14:47
 * @description: Custom Instant Icon created as a React element in a similar manner to react-icons.
 * @notes: Could be moved to icon font file when that is implemented
 */
import React from "react"
import BaseSvgIcon from "./Base"

const Instant = (props) => {
  return (
    <BaseSvgIcon {...props}>
      <path d="M5.916 10.324l1.876-.023c.473-.006.813.448.68.9l-1.63 5.5 6.706-7.175-1.48-.01c-.475-.003-.814-.464-.677-.92l1.622-5.368-7.096 7.097zm-.696 1.008c-.638.007-.962-.765-.51-1.216l8.404-8.405c.524-.526 1.404 0 1.187.71l-1.84 6.098 1.75.01c.623 0 .943.748.517 1.2L6.74 18.273c-.515.55-1.42.03-1.203-.69l1.86-6.278-2.177.027z" />
    </BaseSvgIcon>
  )
}

export default Instant
